import * as React from 'react';
import { SimpleModal } from '../SimpleModal/SimpleModal';
import './ClashEventsModal.scss';

interface Props {
  isOpen: boolean;
  text: string;
  onClose: () => void;
}

export const ClashEventsModal = ({ isOpen, text, onClose }: Props) => {
  const lines = text
    .split('\n')
    .map(line => line.trim())
    .filter(Boolean);
  const intro = lines[0] || '';
  const events = lines.slice(1).map(line => ({
    title: line.replace(/^\d+\.\s*/, '').replace(/\s*\[(Full overlap|Close overlap)\]\s*$/, ''),
    type: line.includes('[Full overlap]') ? 'full' : 'interval'
  }));

  return (
    <SimpleModal
      isOpen={isOpen}
      title="Schedule clash"
      onCloseClick={onClose}
      onBackdropClick={onClose}
      showFooter={false}
      isBodyBold={false}
      customClass="clashEventsModal"
      dialogStyle={{ maxWidth: 520 }}
    >
      <div className="clashEventsModal__content">
        <div className="clashEventsModal__summary">
          <span className="clashEventsModal__signal" aria-label="Schedule clash">
            <i className="is-red" />
            <i className="is-amber" />
            <i className="is-green" />
          </span>
          <div>
            <strong>Conflicting events</strong>
            <p>Review the student’s schedule before changing the participants.</p>
          </div>
        </div>
        <div className="clashEventsModal__person">{intro}</div>
        <div className="clashEventsModal__events">
          {events.map((event, index) => (
            <div className="clashEventsModal__event" key={`${event.title}-${index}`}>
              <i className={`is-${event.type}`} aria-hidden="true" />
              <span>{event.title}</span>
            </div>
          ))}
        </div>
        <div className="clashEventsModal__actions">
          <button type="button" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </SimpleModal>
  );
};
